import {routes as app} from '../app'
import Dashboard from '../app/domains/dashboard/Dashboard'

// Rotas default da aplicação
const root = [
  {
    path: '/',
    component: Dashboard,
    name: 'dashboard',
    meta: {
      breadcrumb: {
        name: 'Dashboard'
      }
    }
  }
]

export default [...root, ...app]



// WEBPACK FOOTER //
// ./src/router/routes.js